import { Form, Card, Table } from "react-bootstrap";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { editNotificationSettings, editUser } from "../services/micro";
import { navigationLabel, navigationItems } from "@revbox/localization";
import { useCookiesContext } from "../contexts/CookiesContext";

export default function NotificationsCard({ user, showOnlyEmails, updateByNotificationToken, userAccesses }) {
  const [emailNotifications, setEmailNotifications] = useState(
    user.email_notifications
  );
  const [pushNotifications, setPushNotifications] = useState(
    user.push_notifications
  );
  const userAllowedNotifications = Notification.permission === "granted";

  const handleEmailNotificationsChange = (key) => {
    let newEmailNotifications = emailNotifications;
    if (emailNotifications.includes(key)) {
      newEmailNotifications = emailNotifications.filter(
        (item) => item !== key
      );
    } else {
      newEmailNotifications = [...emailNotifications, key];
    }

    if (!updateByNotificationToken) {
      editUser(user.id, { email_notifications: newEmailNotifications }).then(
        (response) => {
          if (response.success === false) {
            setEmailNotifications(user.email_notifications);
            toast.error("Error updating email notifications");
          } else {
            setEmailNotifications(newEmailNotifications);
            toast.success("Email notifications updated successfully");
          }
        }
      );
    } else {
      editNotificationSettings({
        email_notifications: newEmailNotifications,
      }).then((response) => {
        if (response.success === false) {
          setEmailNotifications(user.email_notifications);
          toast.error("Error updating email notifications");
        } else {
          setEmailNotifications(newEmailNotifications);
          toast.success("Email notifications updated successfully");
        }
      });
    }
  };

  const handlePushNotificationsChange = (key) => {
    let newPushNotifications = pushNotifications;
    if (pushNotifications.includes(key)) {
      newPushNotifications = pushNotifications.filter((item) => item !== key);
    } else {
      newPushNotifications = [...pushNotifications, key];
    }

    if (!updateByNotificationToken) {
      editUser(user.id, { push_notifications: newPushNotifications }).then(
        (response) => {
          if (response.success === false) {
            setPushNotifications(user.push_notifications);
            toast.error("Error updating push notifications");
          } else {
            setPushNotifications(newPushNotifications);
            toast.success("Push notifications updated successfully");
          }
        }
      );
    } else {
      editNotificationSettings({
        push_notifications: newPushNotifications,
      }).then((response) => {
        if (response.success === false) {
          setPushNotifications(user.push_notifications);
          toast.error("Error updating push notifications");
        } else {
          setPushNotifications(newPushNotifications);
          toast.success("Push notifications updated successfully");
        }
      });
    }
  };

  const {getLanguageAbbr} = useCookiesContext()
  const storedLanguage = getLanguageAbbr()
  const notifyMe = navigationItems[storedLanguage]

  const isInventoryAccess = userAccesses && userAccesses?.includes("inventory_access")
  const isCustomersAccess = userAccesses && userAccesses?.includes("customers_access")
  const isCustomer = user &&user.role === "CUSTOMER"

  return (
    <Card id="notifications" className="card-settings mt-3">
      <Card.Header>
        <Card.Title className="mb-0">{navigationLabel[storedLanguage].notifications}</Card.Title>
      </Card.Header>
      <Card.Body className="">
        <Table className="table-pricing" responsive>
          <thead>
            <tr>
              <th className="w-32"></th>
              <th className={`p-0 ${showOnlyEmails ? "w-full" : "w-17"}`}>
                <span className="mb-0">{notifyMe.basePhrase}</span>
                <div className="pricing-price">{notifyMe.emailNotify}</div>
              </th>
              {!showOnlyEmails && (
                <th className='w-17 p-0'>
                  <span className={`mb-0 ${!userAllowedNotifications ? "op-50" : ''}`}>{notifyMe.basePhrase}</span>
                  <div className={`pricing-price ${!userAllowedNotifications ? "op-50" : ''}`}>{notifyMe.pushNotify}</div>
                  {
                    !userAllowedNotifications ?
                      <div style={{ color: "red", fontWeight: "700" }}>
                        Enable push notifications in your browser
                      </div>
                      :
                      null}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            <tr className="title">
              <td>{notifyMe.titles.general}</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            {
              isCustomer && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.updatesFromPublishers.title}</p>
                    <small>
                      {notifyMe.items.updatesFromPublishers.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("publisher_updates")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("publisher_updates")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  <td></td>
                </tr>
              )}
            <tr>
              <td>
                <p className="mb-1">{notifyMe.items.important.title}</p>
                <small>
                  {notifyMe.items.important.description}
                </small>
              </td>
              <td>
                  <Form.Check
                    type="switch"
                    className="inline-block"
                    disabled
                    checked={
                      emailNotifications &&
                      emailNotifications.includes("important_system_alerts")
                    }
                    onChange={() =>
                      handleEmailNotificationsChange(
                        "important_system_alerts"
                      )
                    }
                  />
              </td>
              {!showOnlyEmails && !isCustomer && (
                <td>
                  <div className="inline-block">
                    <div className="inline-block">
                      <Form.Check
                        type="switch"
                        className="inline-block"
                        disabled
                        checked={
                          pushNotifications &&
                          pushNotifications.includes("important_system_alerts")
                        }
                        onChange={() =>
                          handlePushNotificationsChange(
                            "important_system_alerts"
                          )
                        }
                      />
                    </div>
                  </div>
                </td>
              )}
            </tr>
            {
              !isCustomer && isInventoryAccess && (
                <tr className="title">
                  <td>{notifyMe.titles.inventory}</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              )
            }
            {
              !isCustomer && isInventoryAccess && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.queue.title}</p>
                    <small>
                      {notifyMe.items.queue.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("queue_updates")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("queue_updates")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            disabled={!userAllowedNotifications}
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("queue_updates")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("queue_updates")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )
            }
            {
              !isCustomer && isInventoryAccess && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.inventory.title}</p>
                    <small>
                      {notifyMe.items.inventory.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("inventory_updates")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("inventory_updates")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            disabled={!userAllowedNotifications}
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("inventory_updates")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("inventory_updates")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )
            }
            {
              !isCustomer && isCustomersAccess && (
                <tr className="title">
                  <td>{notifyMe.titles.customers}</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              )
            }
            {
              !isCustomer && isCustomersAccess && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.account.title}</p>
                    <small>
                      {notifyMe.items.account.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("account_updates")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("account_updates")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            disabled={!userAllowedNotifications}
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("account_updates")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("account_updates")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )
            }
            {
              !isCustomer && isCustomersAccess && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.user.title}</p>
                    <small>
                      {notifyMe.items.user.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("users_updates")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("users_updates")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            disabled={!userAllowedNotifications}
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("users_updates")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("users_updates")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )
            }
            {
              !isCustomer && isCustomersAccess && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.campaign.title}</p>
                    <small>
                      {notifyMe.items.campaign.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("campaign_updates")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("campaign_updates")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            disabled={!userAllowedNotifications}
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("campaign_updates")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("campaign_updates")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )
            }
            {
              isCustomer && (
                <tr className="title">
                  <td>{notifyMe.titles.transactional}</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              )}
            {
              isCustomer && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.transactional.title}</p>
                    <small>
                      {notifyMe.items.transactional.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          disabled
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("invoice_receipts")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("invoice_receipts")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            disabled
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("invoice_receipts")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("invoice_receipts")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )}
            {
              isCustomer && (
                <tr className="title">
                  <td>{notifyMe.titles.ppc}</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              )}
            {
              isCustomer && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.ppc.title}</p>
                    <small>
                      {notifyMe.items.ppc.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("outbid_notifications")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("outbid_notifications")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("outbid_notifications")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("outbid_notifications")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )}
            {
              isCustomer && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.bid_approved.title}</p>
                    <small>
                      {notifyMe.items.bid_approved.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("bid_approved")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("bid_approved")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("bid_approved")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("bid_approved")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )}
            {
              isCustomer && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.budget_warnings.title}</p>
                    <small>
                      {notifyMe.items.budget_warnings.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("budget_warnings")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("budget_warnings")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("budget_warnings")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("budget_warnings")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )}
            {
              isCustomer && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.budget_exhaustion.title}</p>
                    <small>
                      {notifyMe.items.budget_exhaustion.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes("budget_exhaustion")
                          }
                          onChange={() =>
                            handleEmailNotificationsChange("budget_exhaustion")
                          }
                        />
                      </div>
                    </div>
                  </td>
                  {!showOnlyEmails && (
                    <td>
                      <div className="inline-block">
                        <div className="inline-block">
                          <Form.Check
                            type="switch"
                            className="inline-block"
                            checked={
                              pushNotifications &&
                              pushNotifications.includes("budget_exhaustion")
                            }
                            onChange={() =>
                              handlePushNotificationsChange("budget_exhaustion")
                            }
                          />
                        </div>
                      </div>
                    </td>
                  )}
                </tr>
              )}
            {
              isCustomer && (
                <tr>
                  <td>
                    <p className="mb-1">{notifyMe.items.monthly_performance_roundups.title}</p>
                    <small>
                      {notifyMe.items.monthly_performance_roundups.description}
                    </small>
                  </td>
                  <td>
                    <div className="inline-block">
                      <div className="inline-block">
                        <Form.Check
                          type="switch"
                          className="inline-block"
                          checked={
                            emailNotifications &&
                            emailNotifications.includes(
                              "monthly_performance_roundups"
                            )
                          }
                          onChange={() =>
                            handleEmailNotificationsChange(
                              "monthly_performance_roundups"
                            )
                          }
                        />
                      </div>
                    </div>
                  </td>
                  <td></td>
                </tr>
              )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}